import { render, staticRenderFns } from "./SimpleProductListSlider.vue?vue&type=template&id=255ffe4c&"
import script from "./SimpleProductListSlider.vue?vue&type=script&lang=js&"
export * from "./SimpleProductListSlider.vue?vue&type=script&lang=js&"
import style0 from "./SimpleProductListSlider.vue?vue&type=style&index=0&id=255ffe4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
